<div class="flex flex-wrap mb-6">

    @let grade = grade$ | async;
    @let user = user$ | async;

    <div class="flex w-full shadow-lg rounded bg-white p-4 flex-row flex-nowrap justify-between">
        <div class="flex flex-col">
            <div class="w-full mb-1">
                <label class="block uppercase text-blueGray-600 text-xs font-bold">
                    Grade
                </label>
                <span class="text-blueGray-600 text-sm">{{grade?.gradeName}}</span>
            </div>
            <div class="w-full mt-4">
                <label class="block uppercase text-blueGray-600 text-xs font-bold">
                    Teacher
                </label>
                <span class="text-blueGray-600 text-sm">{{grade?.teacherName ?? 'Unassigned'}}</span>
            </div>
        </div>
        <div class="flex flex-col justify-end">
            <span class="text-blueGray-600 text-6xl font-bold text-right">{{group?.gradeStats?.[grade?.id ?? '']
                ??
                '-'}}</span>
            <span class="text-blueGray-400 text-sm">Total Students</span>
        </div>
    </div>

    <div class="flex w-full mt-4 shadow-lg rounded bg-white p-4 flex-col justify-between">

        <div class="border-0 w-full">
            <div class="flex flex-row justify-between mb-2">
                <label class="block uppercase text-blueGray-600 text-sm font-bold">
                    Attendance Status
                </label>
                @if (academicYear == group?.academicYear) {
                <button type="button" (click)="getAttendance()"
                    class="px-2 outline-none focus:outline-none focus:ring-0">
                    <i class="fas fa-refresh text-blueGray-300 hover:text-primary-500"></i></button>
                }
            </div>

            @let loadingStudents = (loadingStudents$ | async) ?? false;

            @for (item of students$ | async; track $index) {

            <div class="w-full mt-4 flex flex-row justify-between">
                <div>
                    <a [routerLink]="['students', item.memberId]">
                        <div class="flex items-center">
                            <div class="inline-block flex-none">
                                @if (item.photoURL) {
                                <img [src]="item.photoURL"
                                    class="min-h-12 max-h-12 max-w-12 min-w-12 bg-gray-100 object-cover rounded-full border-none" />
                                }
                                @else {
                                <div
                                    class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                                    {{ item.name | initials }}
                                </div>
                                }
                            </div>
                            <div class="flex-1 inline-flex flex-span ml-3 text-sm font-bold text-blueGray-600">
                                <span>{{item.name ?? 'Unknown'}}</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="min-w-16 flex items-center">
                    <app-progress-determinate [progress]="attendanceMap[item.memberId] || 0">
                    </app-progress-determinate>

                </div>
            </div>
            } @empty {
            @if(!loadingStudents) {
            <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                No Students Found
            </div>
            }
            }
            @if(loadingStudents) {
            <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
                <div class="animate-pulse flex space-x-4">
                    <div class="flex-1 space-y-2">
                        <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                        <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                        <div class="space-y-2">
                            <div class="grid grid-cols-3 gap-4 mb-2">
                                <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                                <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                            </div>
                            <div class="flex flex-row gap-2 justify-start items-center">
                                <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                                <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="flex flex-row w-full justify-center px-4 mt-3">
        <app-btn-more (click)="addMoreStudents()"
            [isDisabled]="loadingStudents || !user?.uid || !groupId"></app-btn-more>
    </div>

</div>